import { createContext, useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { setTelegramId } from '../utils/axios';

const MOCK_TELEGRAM_USER = {
  id: 907423583,
  first_name: 'Test',
  last_name: 'Student',
  username: 'test_student',
};

const initialState = {
  telegramUser: null,
  isReady: false,
  isMock: false,
};

const TelegramContext = createContext(initialState);

TelegramProvider.propTypes = {
  children: PropTypes.node,
};

function TelegramProvider({ children }) {
  const [telegramUser, setTelegramUser] = useState(null);
  const [isReady, setIsReady] = useState(false);
  const [isMock, setIsMock] = useState(false);

  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    const isProduction = process.env.NODE_ENV === 'production';

    // Debug: Telegram WebApp holatini tekshirish
    console.log('[TG] WebApp:', !!tg);
    console.log('[TG] initData:', tg?.initData);
    console.log('[TG] initDataUnsafe:', JSON.stringify(tg?.initDataUnsafe));
    console.log('[TG] user:', JSON.stringify(tg?.initDataUnsafe?.user));

    if (tg && tg.initDataUnsafe?.user) {
      tg.ready();
      tg.expand();
      setTelegramUser(tg.initDataUnsafe.user);
      setTelegramId(tg.initDataUnsafe.user.id);
      setIsMock(false);
    } else if (!isProduction) {
      // Faqat dev muhitda mock user
      console.warn('Telegram WebApp mavjud emas. Mock rejimda ishlamoqda.');
      setTelegramUser(MOCK_TELEGRAM_USER);
      setTelegramId(MOCK_TELEGRAM_USER.id);
      setIsMock(true);
    } else {
      console.error('[TG] Production: Telegram WebApp user topilmadi!');
    }

    setIsReady(true);
  }, []);

  const value = useMemo(
    () => ({
      telegramUser,
      isReady,
      isMock,
    }),
    [telegramUser, isReady, isMock]
  );

  return <TelegramContext.Provider value={value}>{children}</TelegramContext.Provider>;
}

export { TelegramContext, TelegramProvider };
